import React from 'react';
import { useSelector } from 'react-redux';

import useStatusEditProject from '../hooks/useStatusEditProject';
import { RootState } from '../store';
import { ItemType } from '../types';
import GantItemMarkerBond from './gantItemMarkerBond';

interface IGantItemParent {
    item: ItemType;
    x: number;
    widthItem: number;
    isOverMouse: boolean;
}

const GantItemSetMarkerBond: React.FC<IGantItemParent> = ({ item, x, widthItem, isOverMouse }) => {
    const currentDragBond = useSelector<RootState, ItemType | null>((state) => state.gantDraggable.currentDragBond);
    const currentGantItem = useSelector<RootState, ItemType | null>((state) => state.gantItems.currentGantItem);

    const isEditableProject = useStatusEditProject(item.projectId);

    const offset = item.children ? 0 : 2;

    return (
        <>
            {(isOverMouse || item.id === currentGantItem?.id) &&
                isEditableProject &&
                item.roleItem !== 'project' &&
                !currentDragBond && (
                    <>
                        <GantItemMarkerBond item={item} x={x + offset} draggingType={'bondLeft'} />
                        <GantItemMarkerBond item={item} x={x + widthItem - offset} draggingType={'bondRight'} />
                    </>
                )}
        </>
    );
};

export default React.memo(GantItemSetMarkerBond);
